<template>
    <div class="container">
        <ProductsMenu @productsSelect="productsSelect"/>
        <div>
            <div class="introduction" >
                <div class="introductionTitle">
                    <h1 data-aos="fade-up">BioCloud多中心生物样本资源共享平台</h1>
                    <div data-aos="fade-up"></div>
<!--                    <div data-aos="fade-up">-->
<!--                        生物样本资源共享是生命科学发展的重要趋势，也是衡量一个国家生物技术水平的重要标志。多中心生物样本资源共享平台的建设使参与中心实现资源互通和信息互动，代表该领域的最新进展与发展方向。-->
<!--                    </div>-->
                    <div data-aos="fade-up">
                      BioCloud 多中心生物样本资源共享平台，是面向生物样本库之间开展资源共享与信息交流的信息管理系统。平台具备样本信息共享、资源互借、项目合作、信息交流、中心业务评价等功能，采用规范化整合机制，结合数据脱敏与加密手段，并对数据交互记录进行实时核对，强化样本信息完整性与隐私防护，支撑各生物样本库开展信息、资源与项目层面的交流互动，提升样本资源的利用率与使用效能。平台适配临床科研单位、药物研发企业、政府决策机构等多类使用主体，依托标准化应用与服务，助力打通跨机构、跨地区科研协作链路，为实现相关科学价值与社会价值提供支撑。
                    </div>
                </div>
                <div data-aos="zoom-in" style="padding: 20px 10px;background:#fff;box-shadow: 0 0 50px #c4deff;border-radius: 50%">
                    <img :src="require('@/assets/img/products/share/shareTitle.png')" alt="" style="border-radius: 50%">
                </div>
            </div>
            <div class="productsIntroduction">
                <div class="title" data-aos="fade-up">产品介绍</div>
                <div class="content ">
                    <div class="title" data-aos="fade-up">生物样本与样本信息</div>
                    <div class="text" data-aos="fade-up">唐颐BioCloud多中心生物样本资源共享平台整合多个祥本库下患者的各类生物样本及样本信息</div>
                    <div class="tissue">
                        <div v-for="item in tissue" data-aos="fade-up">
                            <div>{{item.title}}</div>
                            <div v-for="list in item.list" class="list">
                                <img :src="list.src" alt="" height="30">
                                <div>{{list.title}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="title" data-aos="fade-up">面向对象</div>
                    <div class="text" data-aos="fade-up">BioCloud 多中心生物样本资源共享平台服务于医院、高校、临床科研机构、生物制药厂商、CRO 机构等各类机构客户，提供完整的生物样本资源共享数字化解决方案，充分释放样本资源的数据潜力，深度挖掘医学科研价值与社会价值。
                    </div>
                    <div class="obj" data-aos="fade-up">
                        <div v-for="item in obj">
                            <img :src="item.src" alt="">
                            <div>{{item.title}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="case">
                <div>
                    <div class="title" data-aos="fade-up-right">案例分析</div>
                </div>
                <div>
                    <div class="content">
                        <img :src="require('@/assets/img/products/share/caseContent.png')" alt="" data-aos="zoom-in" style="width:90%">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WOW from '../../../node_modules/wowjs/dist/wow';
import ProductsMenu from "../../components/ProductsMenu";
export default {
    name:'Share',
    components: {ProductsMenu},
    data(){
      return {
          tissue:[
              {
                  title:'生物样本',
                  list:[
                      {
                          title:'生物大分子',
                          src:require('@/assets/img/products/share/tissue1.png')
                      },
                      {
                          title:'细胞',
                          src:require('@/assets/img/products/share/tissue2.png')
                      },
                      {
                          title:'组织',
                          src:require('@/assets/img/products/share/tissue3.png')
                      },
                      {
                          title:'器官',
                          src:require('@/assets/img/products/share/tissue4.png')
                      },
                      {
                          title:'DNA',
                          src:require('@/assets/img/products/share/tissue5.png')
                      },
                      {
                          title:'RNA',
                          src:require('@/assets/img/products/share/tissue6.png')
                      }
                  ]
              },
              {
                  title:'样本信息',
                  list:[
                      {
                          title:'临床诊断信息',
                          src:require('@/assets/img/products/share/tissue7.png')
                      },
                      {
                          title:'病例信息',
                          src:require('@/assets/img/products/share/tissue8.png')
                      },
                      {
                          title:'治疗信息',
                          src:require('@/assets/img/products/share/tissue9.png')
                      },
                      {
                          title:'随访',
                          src:require('@/assets/img/products/share/tissue10.png')
                      },
                      {
                          title:'知情同意书',
                          src:require('@/assets/img/products/share/tissue11.png')
                      }
                  ]
              }
          ],
          obj:[
              {
                  title:'医院',
                  src:require('@/assets/img/products/share/obj1.png')
              },
              {
                  title:'高校',
                  src:require('@/assets/img/products/share/obj2.png')
              },
              {
                  title:'科研机构',
                  src:require('@/assets/img/products/share/obj3.png')
              },
              {
                  title:'药厂',
                  src:require('@/assets/img/products/share/obj4.png')
              },
              {
                  title:'政府',
                  src:require('@/assets/img/products/share/obj5.png')
              },
              {
                  title:'保险公司',
                  src:require('@/assets/img/products/share/obj6.png')
              },
              {
                  title:'CRO机构',
                  src:require('@/assets/img/products/share/obj7.png')
              },
              {
                  title:'......更多',
                  src:require('@/assets/img/products/share/obj8.png')
              },
          ]
      }
    },
    mounted() {
        let wow = new WOW.WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 0,
            mobile: true,
            live: true
          });
          wow.init();
    },
    methods:{
        productsSelect(src){
	        this.$emit('productsSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .introduction{
        width: 1170px;
        margin: 120px auto 0;
        display: flex;
        justify-content: space-between;
        .introductionTitle{
            width: 610px;
            padding-top: 100px;
            h1{
                font-size: 19px;
            }
            &>div:nth-child(2){
                width: 65px;
                height: 2px;
                background: #006efd;
                margin: 13px 0 50px 0px;
            }
            &>div:nth-child(3),&>div:nth-child(4){
                font-size: 14px;
                line-height: 30px;
                letter-spacing: 1px;
                text-indent: 2em;
                color: rgb( 51, 51, 51 );
            }
        }
        &>div:nth-child(2){
            width: 400px;
            height: 400px;
            box-sizing: border-box;
            margin-top: 80px;
        }
    }
    .productsIntroduction{
         width: 1017px;
         margin: 183px auto 0;
        .title{
            height: 60px;
            text-align: center;
            font-size: 28px;
            color: #ed1c24;
            letter-spacing: 2px;
            background: url('../../assets/img/products/share/productsIntroduction.png') center no-repeat;
        }
        .content{
            margin-top: 100px;
            .title{
                width: 226px;
                height: 25px;
                line-height: 25px;
                text-align: center;
                font-size: 18px;
                letter-spacing: 2px;
                color: #fff;
                background: #006efd;
            }
            .text{
                font-size: 14px;
                letter-spacing: 2px;
                margin-top: 15px;
                margin-bottom: 80px;
            }
        }
        .tissue{
            &>div{
                display: flex;
                justify-content: space-between;
                padding-left: 45px;
                margin-top: 12px;
                &>div:nth-child(1){
                    width: 109px;
                    height: 141px;
                    box-sizing: border-box;
                    border: 1px solid #006efd;
                    text-align: center;
                    line-height: 141px;
                    letter-spacing: 2px;
                    color: #006efd;
                    font-weight: 500;
                    font-size: 19px;
                    position: relative;
                }
                &>div:nth-child(1):before,&>div:nth-child(1):after{
                    display: block;
                    content: '';
                    position: absolute;
                    left: 107px;
                    top: 59px;
                    width: 0;
                    height:0;
                    border: 13px solid transparent;
                }
                 &>div:nth-child(1):before{
                    border-left-color:#006efd ;
                     left: 108px;
                 }
                 &>div:nth-child(1):after{
                    border-left-color:#fff ;
                 }
                .list{
                    box-sizing: border-box;
                    height: 141px;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-wrap: wrap;
                    padding: 10px 0;
                    div{
                        width: 100%;
                        letter-spacing: 1px;
                        font-size: 14px;
                    }
                }
            }
        }
        .obj{
            width: 791px;
            margin: 73px auto 0;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            &>div{
                width: 159px;
                height: 152px;
                box-shadow: 0 0 10px #ededed;
                margin-bottom: 48px;
                img{
                    width: 100%;
                    height: 103px;
                }
                &>div{
                    height: 49px;
                    text-align: center;
                    line-height: 49px;
                    letter-spacing: 1px;
                    margin-top: -3.5px;
                }
            }
            &>div:nth-child(5) div{
                margin-top: 0;
            }
        }
    }
    .case{
        width: 100%;
        height: 650px;
        display: flex;
        margin-bottom: 133px;
        margin-top: 60px;
        &>div:nth-child(1){
            width: 50%;
            height: 100%;
            background: #faf9f9;
            position: relative;
            div{
                width: 480px;
                height: 200px;
                box-shadow: 0 0 10px #dedede;
                position: absolute;
                right: -103px;
                top: 220px;
                background: url("../../assets/img/products/share/caseTitle.png") no-repeat #fff -10px;
                border-radius: 10px;
                line-height: 200px;
                font-size: 28px;
                color: #006efd;
                letter-spacing: 2px;
                text-align: center;
                z-index: 99;
            }
        }
        &>div:nth-child(2){
            width: 50%;
            height: 100%;
            background: #006efd;
            box-sizing: border-box;
            padding-left: 54px;
            padding-top: 136px;
        }
    }
</style>
